module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-event-listener/~/babel-runtime/core-js/symbol/iterator.js
 ** module id = 801
 ** module chunks = 3
 **/